import { render, staticRenderFns } from "./SuperAdminSyncIssues.vue?vue&type=template&id=4474279f&scoped=true"
import script from "./SuperAdminSyncIssues.vue?vue&type=script&lang=js"
export * from "./SuperAdminSyncIssues.vue?vue&type=script&lang=js"
import style0 from "./SuperAdminSyncIssues.vue?vue&type=style&index=0&id=4474279f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4474279f",
  null
  
)

export default component.exports